import type { IconData } from '@stacksjs/iconify-core'

export const bomb: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"m36.489 11.388l.235-.294a6 6 0 0 1 7.773-1.397L45 10m-25 1c9.389 0 17 7.611 17 17s-7.611 17-17 17S3 37.389 3 28s7.611-17 17-17\"/><path d=\"m35.53 21.072l2.135-2.136c1.454-1.454 2.012-3.577.81-5.245a18 18 0 0 0-1.925-2.242a18 18 0 0 0-2.242-1.925c-1.668-1.201-3.791-.644-5.245.81l-2.136 2.136M20 17c-6.075 0-11 4.925-11 11\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bomb
